import { useEditor } from '@mnz/builder';
import React, { FC, Fragment, ReactElement, useEffect } from 'react';
import { useTheme } from '@mui/material';

interface RenderNodeProps {
    render: ReactElement;
}

const RenderNode: FC<RenderNodeProps> = ({ render }) => {
    const theme = useTheme();
    const { enabled, nodes } = useEditor((_, query) => ({
        nodes: query.getNodes(),
        enabled: query.getState().options.enabled,
    }));

    useEffect(() => {
        if (!enabled) {
            return;
        }
        Object.keys(nodes).forEach((key) => {
            const node = nodes[key];
            const { dom, data } = node;
            if (dom && data.custom?.showBox) {
                dom.style.outlineStyle = 'dashed';
                dom.style.outlineColor = theme.palette.success.main;
                dom.style.outlineWidth = 'medium';
                dom.style.outlineOffset = `1px`;
                dom.style.borderRadius = `2px`;
                dom.style.cursor = `pointer`;
            }
        });
    }, [nodes]);

    return <Fragment>{render}</Fragment>;
};

export default RenderNode;
